<template>
<v-card v-if="!clientUserAgent" flat>
    <v-dialog v-model="showDeleteModal" persistent max-width="290">
        <v-card>
            <v-toolbar color="orange" dark small>
                <v-toolbar-title>Delete {{deleteType=='truck' ? 'Truck' : 'Template'}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn dark icon @click="showDeleteModal=false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                Are you sure you want to delete this {{deleteType}}?
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="dark" small @click="showDeleteModal=false">
                    No
                </v-btn>
                <v-btn color="orange " class="white-text" small @click="deleteTruck">
                    Yes
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-toolbar color="orange" dark>
        <v-flex xs4 class="text-xs-center">
        </v-flex>
        <v-flex xs4 class="text-xs-center">
            <h4 class="body-2 font-weight-bold white--text">SEARCH RESULTS</h4>
            <span class="d-block mb-3 caption white--text text--lighten-1">{{trucks.length}} exact matches</span>
        </v-flex>
        <v-flex xs4 class="text-xs-center">
            <v-layout align-center justify-end row fill-height class="text-xs-right">
                <v-flex xs8>
                    <v-btn color="white" @click="getTrucks" class="blackText">
                        <i class="fas fa-sync-alt"></i> REFRESH RESULTS </v-btn>
                </v-flex>
                <v-flex xs4>
                    <v-select v-model="refreshRate" @change="setInterval" :items="[{'text': 'Never', value: false}, {'text': '10 sec', value: 10}, {'text': '30 sec', 'value':30}, {'text': '60 sec', 'value':60}, {'text': '5 min', 'value':300}, {'text': '10 min', 'value':600}]" dark class="black--text textselect"></v-select>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-toolbar>
    <v-toolbar color="grey darken-1" dark>
        <v-flex xs12 md3>
            PAGE {{pagination.currPage}} of {{pagination.maxPages}} ({{trucks.length}} {{trucks.length > 1 ? 'TRUCKS': 'TRUCKS'}})
        </v-flex>
        <v-flex xs12 md6 class="text-xs-center">
            <v-pagination v-if="trucks.length" v-model="pagination.currPage" @input="onPageChange" :length="pagination.maxPages" :total-visible="7"></v-pagination>
        </v-flex>
        <v-flex xs12 md3 class="text-xs-right">
            <v-layout align-center justify-end row fill-height class="text-xs-right">
                <v-flex xs8 class="text-xs-right"> SHOW</v-flex>
                <v-flex xs4 class="text-xs-right">
                    <v-select v-model="pagination.perPage" @input="setPerPage" :items="[{'text': '10', value: 10}, {'text': '25', 'value':25}, {'text': '50', 'value':50},{'text': '100', 'value':100}]"></v-select>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-toolbar>
    <div class="v-table__overflow">
        <table class="custom_table" cellpadding="0" width="100%">
            <thead>
                <tr>
                    <th @click="switchSort('age', 'num')" class="sortable" width="50px">
                        <v-icon color="orange">{{getSortArrow('age')}}</v-icon>Age
                    </th>
                    <th width="150px" @click="switchSort('origin')" class="sortable">
                        <v-icon color="orange">{{getSortArrow('origin')}}</v-icon>ORIGIN
                    </th>
                    <th width="150px" @click="switchSort('dest')" class="sortable">
                        <v-icon color="orange">{{getSortArrow('dest')}}</v-icon>DESTINATION
                    </th>
                    <th width="150px">
                        <table width="100%" border="0" cellpadding="0" class="subtable">
                            <tr rowspan="2">
                                <td @click="switchSort('available_date')" class="sortable">
                                    <v-icon color="orange">{{getSortArrow('available_date')}}</v-icon>AVAILABILITY
                                </td>
                            </tr>
                        </table>
                    </th>
                    <th width="150px">
                        <table width="100%" border="0" cellpadding="5" class="subtable">
                            <tr>
                                <td colspan="2">
                                    Equipment
                                </td>
                            </tr>
                            <tr>
                                <td @click="switchSort('load_size')" class="sortable" width="45%">
                                    <v-icon color="orange">{{getSortArrow('load_size')}}</v-icon>Size
                                </td>
                                <td @click="switchSort('length', 'num')" class="sortable" width="55%">
                                    <v-icon color="orange">{{getSortArrow('length')}}</v-icon>Length
                                </td>
                            </tr>
                        </table>
                    </th>
                    <th width="150px">
                        <table width="100%" border="0" cellpadding="5" class="subtable">
                            
                            <tr rowspan="2">
                                <td @click="switchSort('weight', 'num')" class="sortable">
                                    <v-icon color="orange">{{getSortArrow('weight')}}</v-icon>Weight
                                </td>
                            </tr>
                        </table>
                    </th>
                    <th width="150px">
                        <table width="100%" border="0" cellpadding="5" class="subtable">
                            <tr rowspan="2">
                                <td @click="switchSort('contact_phone', 'num')" class="sortable" width="61%">
                                    <v-icon color="orange">{{getSortArrow('contact_phone')}}</v-icon>Phone
                                </td>
                            </tr>
                        </table>
                    </th>
                    <th width="150px">
                        <table width="100%" border="0" cellpadding="5" class="subtable">
                            <tr rowspan="2">
                                <td>Actions</td>
                            </tr>
                        </table>
                    </th>
                </tr>
            </thead>
            <tbody v-if="trucks.length">
                <template v-for="(truck, index) in pageTrucks">
                    <tr v-bind:key="index" class="custom_table_tr" v-on:click="selectedRow=selectedRow && selectedRow.uuid===truck.uuid ? {} : truck">
                        <td align="center">
                            <v-chip label color="orange" class="sm-case" text-color="white">{{truck.age_display}} </v-chip>
                        </td>
                        <td colspan="2">
                            <table width="100%" border="0" cellpadding="0" class="subtableNO">
                                <tr>
                                    <td width="45%" class="bold origin_city">{{utils.displayCityStateAny(truck.origin_city, truck.origin_state,truck.origin_short_name)}}
                                    </td>
                                    <td width="10%" align="center">
                                        <v-icon color="orange">arrow_forward</v-icon>
                                    </td>
                                    <td width="45%" class="bold dest_city">{{utils.displayCityStateAny(truck.dest_city, truck.dest_state,truck.dest_short_name)}}</td>
                                </tr>
                            </table>
                        </td>
                        <td>
                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                <tr>
                                    <td align="center">{{truck.available_date | moment("utc","MM/DD")}}</td>
                                </tr>
                            </table>
                        </td>
                        <td>
                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                <tr>
                                    <td colspan="2" align="center">{{truck.equipment_name}}</td>
                                </tr>
                                <tr>
                                    <td width="50%" align="center">{{truck.load_size}}</td>
                                    <td width="50%" class="sm-case length" align="center">{{truck.length}} ft</td>
                                </tr>
                            </table>
                        </td> 
                        <td>
                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                
                                <tr rowspan="2">
                                    <td align="center">{{truck.weight}} lbs</td>
                                </tr>
                            </table>
                        </td>
                        <td>
                            <table width="100%" border="0" cellpadding="0" class="subtable">
                                <tr rowspan="2">
                                    <td align="center"> <a class="link-text" target="_blank"  :href="'tel:' + truck.contact_phone" >{{truck.contact_phone | phone}}</a></td>
                                </tr>
                            </table>
                        </td>
                        <td>
                            <table width="100%" border="0" cellpadding="0" class="subtable action">
                                <tr rowspan="2">
                                    <td align="center">
                                        <v-btn depressed outline icon fab dark color="orange" small>
                                            <v-icon color="orange">fa-eye</v-icon>
                                        </v-btn>
                                        <v-btn v-if="permissionName=='all' && truck.email == $store.state.user.email" :to="{name:'EditSearchTruck', params:{id:truck.uuid}}" depressed outline icon fab dark color="orange" small>
                                            <v-icon>fa-edit</v-icon>
                                        </v-btn>
                                        <v-btn v-if="permissionName=='all' && truck.email == $store.state.user.email" depressed outline icon fab dark color="red" small v-on:click.stop="showDeleteModal=true; deleteId=truck.uuid; deleteIndex=truck.ind; deleteType='truck'">
                                            <v-icon>fa-trash</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr v-if="selectedRow.uuid && selectedRow.uuid===truck.uuid" v-bind:key="`${index+'detail'}`">
                        <td colspan="8" align="center" v-html="getRowDetail(truck, renderMap, 'truck')">
                        </td>
                    </tr>
                </template>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="8" align="center" class="noRecord" valign="middle">
                        {{noRecordFoundStrForSearch}}
                        <br/>
                        <a @click="toTop">{{goToFiltersText}}</a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <v-toolbar color="grey darken-1" dark>
        <v-flex xs12 md3>
            PAGE {{pagination.currPage}} of {{pagination.maxPages}} ({{trucks.length}} {{trucks.length > 1 ? 'TRUCKS': 'TRUCKS'}})
        </v-flex>
        <v-flex xs12 md6 class="text-xs-center">
            <v-pagination v-if="trucks.length" v-model="pagination.currPage" @input="onPageChange" :length="pagination.maxPages" :total-visible="7"></v-pagination>
        </v-flex>
        <v-flex xs12 md3 class="text-xs-right">
            <v-layout align-center justify-end row fill-height class="text-xs-right">
                <v-flex xs8 class="text-xs-right"> SHOW</v-flex>
                <v-flex xs4 class="text-xs-right">
                    <v-select v-model="pagination.perPage" @input="setPerPage" :items="[{'text': '10', value: 10}, {'text': '25', 'value':25}, {'text': '50', 'value':50},{'text': '100', 'value':100}]"></v-select>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-toolbar>

</v-card>

<v-card v-else flat>
    <div class="v-table__overflow">
        <table class="custom_table mobileview" cellpadding="0" width="100%">
            <tbody v-if="trucks.length">
                <template v-for="(truck, index) in pageTrucks">
                    <tr v-bind:key="index" class="custom_table_tr" v-on:click="selectedRow=selectedRow && selectedRow.uuid===truck.uuid ? {} : truck">
                        <td>
                            <table width="100%" border="0" cellpadding="0" class="subtableNO">
                                <tr>
                                    <td width="45%" class="bold" valign="top">
                                        <h1>{{utils.displayCityStateAny(truck.origin_city, truck.origin_state,truck.origin_short_name)}} </h1>{{truck.available_date | moment("dddd, MMMM. Do")}}<br/>
                                        {{truck.age_display}}
                                    </td>
                                    <td width="10%" align="center" valign="top">
                                        <h1>
                                            <v-icon color="orange">arrow_forward</v-icon>
                                        </h1>
                                    </td>
                                    <td width="45%" class="bold" valign="top">
                                        <h1>{{utils.displayCityStateAny(truck.dest_city, truck.dest_state,truck.dest_short_name)}}
                                        </h1>
                                        {{truck.load_size}}
                                        <br/>
                                        {{truck.company_name}}
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr v-if="selectedRow.uuid && selectedRow.uuid===truck.uuid" v-bind:key="`${index+'detail'}`">
                        <td align="center" v-html="getRowDetail(truck, renderMap, 'truck')">
                        </td>
                    </tr>
                </template>
            </tbody>
            <tbody v-else>
                <tr>
                    <td align="center" class="noRecord" valign="middle">{{noRecordFoundStrForSearch}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</v-card>
</template>

<script>
import utils from '../../util/';
import services from "../../services/HttpService";
import config from "../../config";
export default {
    props: [
        "trucks",
        "getTrucks",
        "type",
        "selectedTab",
        "permissionName",
        "clientUserAgent"
    ],
    created() {
        this.utils = utils;
    },
    mounted() {
        this.setInterval();
    },
    watch: {
        trucks: function (newVal, oldVal) {
            this.onPageChange(1);
        },
        selectedTab: function (newVal, oldVal) {
            clearTimeout(window.intervals.city);
            clearTimeout(window.intervals.map);
            this.setInterval();
        }
    },
    data() {
        return {
            goToFiltersText:config.goToFiltersText, 
            currDate: new Date(),
            pageTrucks: [],
            selectedRow: {},
            currentSorting: null,
            deleteType: 'truck',
            sortType: 'asc',
            pagination: {
                currPage: 1,
                perPage: 10,
                tmpPerPage: 0,
                maxPages: 0
            },
            refreshRate: false,
            interval: 0,
            showDeleteModal: false,
            noRecordFoundStrForSearch:config.noRecordFoundStrForSearch,
            anywhereStr:config.anywhereStr
        }
    },
    methods: {
        toTop () {
            this.$router.push({ hash: '' });
            this.$vuetify.goTo(0);
        },
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        setPerPage(page) {
            if (page != this.pagination.tmpPerPage) {
                this.pagination.tmpPerPage = page;
                this.onPageChange(1);
            }
        },
        setInterval() {
            const self = this;
            if ((self.selectedTab === 0 && this.type !== 'city') || (self.selectedTab === 1 && this.type !== 'map')) {
                return;
            }
            clearInterval(self.interval);
            if (self.refreshRate === false) {
                return;
            }
            if (self.getTrucks) {
                self.interval = setInterval(() => {
                    self.getTrucks();
                }, self.refreshRate * 1000);
                if (self.type) {
                    window.intervals[self.type] = self.interval;
                }
            }
        },
        onPageChange(page) {
            this.pagination.currPage = page;
            const perPg = this.pagination.perPage;
            this.countMaxPages();
            const offset = page <= 1 ? 0 : ((page - 1) * perPg);
            const limit = offset + perPg;
            if(this.clientUserAgent){
                this.pageTrucks = this.trucks;
            } else {
                this.pageTrucks = this.trucks.slice(offset, limit);
            }            
        },
        countMaxPages() {
            this.pagination.maxPages = Math.ceil(this.trucks.length / this.pagination.perPage);
            if (this.pagination.maxPages == 0) {
                this.pagination.maxPages = 1;
            }
        },
        getSortArrow(field) {
            let arr = 'arrow_drop_up';
            if (this.currentSorting === field && this.sortType === 'desc') {
                arr = 'arrow_drop_down';
            }
            return arr;
        },
        switchSort(field, valType = 'str') {
            this.currentSorting = field;
            if (field === this.currentSorting) {
                this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
            } else {
                this.sortType = 'asc';
            }
            if (this.trucks.length > 1) {
                this.trucks.sortBy(field, this.sortType, valType);
                this.onPageChange(this.pagination.currPage);
            }
        },
        _getPhoneFormat(phone) {
            if (phone && phone.length > 0) {
                if (phone.length == 11) {
                    return phone.replace(/[^0-9]/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1($2) $3-$4');
                } else {
                    return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '1($1) $2-$3');
                }
            } else {
                return config.notProvidedStr;
            }
        },
        _getData(fieldName) {
            if (fieldName && fieldName.length > 0) {
                return fieldName;
            } else {
                return config.notProvidedStr;
            }
        },
        getRowDetail(truck, cb, type) {
            const self = this,
                r = this.selectedRow;
                if (!self.clientUserAgent) {
                setTimeout(() => {
                    cb(r.uuid + '-map', truck);
                }, config.setTimeOutForLoadAndTruckDetailMap);
                let html = `<table width="100%" border="0" cellpadding="0" class="subtable viewdetail">
                    <tr>
                        <th align="center" width="30">
                            CARRIER
                        </th>
                        <th align="center" width="30"> TRUCK </th>
                        <th align="center" width="40" class="pos-relative">DESTINATION`;
                if (type == 'truck') {
                    html += `<a class="v-btn--router v-chip v-chip--label orange white--text full-load-btn" href='/trucksearch/detail/` + r.uuid + `'>FULL VIEW</a>`;
                }
                html += `</th>
                    </tr>
                    <tr>
                        <td valign="top" align="left" width="30%">
                            <div class='unset-case'>
                                <strong>Name:</strong> ` + utils.getDataDisplay(r.contact_name) + `<br />
                                    <strong>Phone No.:</strong> `;
                                    let phone = utils.getPhoneFormatDisplay(r.contact_phone);
                                    if (phone != config.notProvidedStr) {
                                        html += `<a class="link-text" target="_blank" href="tel:` + phone + `">` + phone + `</a>`;
                                    } else {
                                        html += phone;
                                    }
                                    html += `<br />
                                    <strong>Email:</strong> `;
                                    let email = utils.getDataDisplay(r.contact_email);
                                    if (email != config.notProvidedStr) {
                                        html += `<a class="link-text" target="_blank" href="mailto:` + email + `">` + email + `</a>`;
                                    } else {
                                        html += email;
                                    }
                                    html += `<br />
                                    <strong>Company:</strong> ` + utils.getDataDisplay((type == 'truck') ? r.company_name : r.User.company_name) + ` <br />
                                    <strong>MC Number:</strong> `;
                                    let mcNumber = utils.getDataDisplay((type == 'truck') ? r.mc_number : r.User.mc_number);
                                    if (mcNumber != config.notProvidedStr) {
                                        html += `<a class="link-text" target="_blank" href="`+config.mcNumberLocation+mcNumber+`">`+mcNumber+`</a>`;
                                    } else {
                                        html += mcNumber;
                                    }
                                    html += `<br />
                                    <strong>LOADMAX Forum Username:</strong> ` + utils.getDataDisplay((type == 'truck') ? r.discourse_user_name : r.User.discourse_user_name) + ` <br />
                                </div>
                            </td>
                            <td valign="top" align="left" width="30%">
                                <div class='unset-case'>
                                    <strong>Height:</strong> ` + r.height + ` ft<br />
                                    <strong>Weight:</strong> ` + r.weight + ` lbs<br />
                                    <strong>Length:</strong> ` + r.length + ` ft<br />
                                    <strong>Equipment and Accessories:</strong> ` + r.equipment_name + `<br />
                                    <strong>Descriptions and Comments:</strong> ` + utils.getDescriptionDisplay(r.description)+ `<br />
                                    <strong>Lead Number/Name:</strong> ` + utils.getDataDisplay(r.reference_number) + `<br />
                                </div>
                            </td>
                            <td valign="top" align="left" width="40%">
                                <div style="height:200px;" id="` + r.uuid + `-map"></div>
                            </td>
                        </tr>
                    </table>`;
                return html;
            }else{
                let html = `<div class="mobilefullLoad"><div class='unset-case'>
                <h1>BROKER</h1>
                <strong>Name:</strong> ` + utils.getDataDisplay(r.contact_name) + `<br />
                <strong>Phone:</strong> `;
                let phone = utils.getPhoneFormatDisplay(r.contact_phone);
                if (phone != config.notProvidedStr) {
                    html += `<a class="link-text" target="_blank" href="tel:` + phone + `">` + phone + `</a>`;
                } else {
                    html += phone;
                }
                html += `<br />
                <strong>Company:</strong> ` + utils.getDataDisplay((type == 'truck') ? r.company_name : r.User.company_name) + ` <br />
                <strong>Email:</strong> `;
                let email = utils.getDataDisplay(r.contact_email);
                if (email != config.notProvidedStr) {
                    html += `<a class="link-text" target="_blank" href="mailto:` + email + `">` + email + `</a>`;
                } else {
                    html += email;
                }
                html += `<br />
                <strong>MC Number:</strong> `;
                let mcNumber = utils.getDataDisplay((type == 'truck') ? r.mc_number : r.User.mc_number);
                if (mcNumber != config.notProvidedStr) {
                    html += `<a class="link-text" target="_blank" href="`+config.mcNumberLocation+mcNumber+`">`+mcNumber+`</a>`;
                } else {
                    html += mcNumber;
                }
                html += `<br />
                <strong>LOADMAX Forum Username:</strong> ` + utils.getDataDisplay((type == 'truck') ? r.discourse_user_name : r.User.discourse_user_name) + ` <br />
                </div>
                <div class='unset-case'>
                    <h1>LOAD</h1>
                        <strong>Height:</strong> ` + r.height + ` ft<br />
                        <strong>Weight:</strong> ` + r.weight + ` lbs<br />
                        <strong>Length:</strong> ` + r.length + ` ft<br />
                        <strong>Equipment and Accessories:</strong> ` + r.equipment_name + `<br />
                        <strong>Descriptions and Comments:</strong> ` + utils.getDescriptionDisplay(r.description)+`<br />
                        <strong>Lead Number/Name:</strong> ` + utils.getDataDisplay(r.reference_number) + `<br />
                </div>
                <a class="v-btn--router orange white--text btnfull " href='/trucksearch/detail/` + r.uuid + `'>FULL VIEW</a>
                </div>`;
                return html;
            }
        },
        renderMap(id, truck) {
            let startAdd = new google.maps.LatLng(truck.origin_lat, truck.origin_lng);
            let endAdd = new google.maps.LatLng(truck.dest_lat, truck.dest_lng);
            const directionsDisplay = new google.maps.DirectionsRenderer,
                directionsService = new google.maps.DirectionsService;
            const map = new google.maps.Map(document.getElementById(id), {
                zoom: 7,
                center: {
                    lat: 41.85,
                    lng: -87.65
                }
            });
            directionsDisplay.setMap(map);
            directionsService.route({
                origin: truck.origin_lat + "," + truck.origin_lng,
                destination: truck.dest_lat + "," + truck.dest_lng,
                travelMode: 'DRIVING'
            }, function (response, status) {
                if (status === 'OK') {
                    let startContentString = '<div id="content" class="MarkerLabelFontCls">' + response.routes[0].legs[0].start_address + '</div>';
                    let startInfowindow = new google.maps.InfoWindow({
                        content: startContentString
                    });
                    // The marker, positioned at Uluru
                    let startMarker = new google.maps.Marker({
                        position: startAdd,
                        map: map,
                        icon: '/static/icon/map-marker-a.svg',
                        zIndex: 999
                    });
                    startMarker.addListener('click', function () {
                        startInfowindow.open(map, startMarker);
                    });


                    let endContentString = '<div id="content" class="MarkerLabelFontCls">' + response.routes[0].legs[0].end_address + '</div>';
                    let endInfowindow = new google.maps.InfoWindow({
                        content: endContentString
                    });
                    // The marker, positioned at Uluru
                    var endMarker = new google.maps.Marker({
                        position: endAdd,
                        map: map,
                        icon: '/static/icon/map-marker-b.svg',
                        zIndex: 999
                    });
                    endMarker.addListener('click', function () {
                        endInfowindow.open(map, endMarker);
                    });
                    directionsDisplay.setDirections(response);
                }
            });
        },
        deleteTruck() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.showDeleteModal = false
            services
                .delete('trucks/delete', {
                    uuid: self.deleteId
                }, {
                    Authorization: "Bearer " + this.$store.state.user.token
                })
                .then(res => {
                    if (res.status === 200) {
                        self._showToast(res.data.message, res.data.is_error ? config.errMsgColorStr : config.successMsgColorStr);
                        wApp.$emit("showLoader", {
                            show: false
                        });
                        self._sliceFromArr(self.trucks);
                        self.countMaxPages();
                        if (self.pagination.maxPages < self.pagination.currPage) {
                            self.onPageChange(self.pagination.maxPages);
                        } else {
                            self.onPageChange(self.pagination.currPage);
                        }
                    }
                    self.deleteId = null;
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, config.errMsgColorStr);
                    self.deleteId = null;
                });
        },
        _sliceFromArr(data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i].ind == this.deleteIndex) {
                    data.splice(i, 1);
                    break;
                }
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/trucks/SearchTable.vue